import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const TermsPage = () => (
  <Box sx={{ maxWidth: 800, mx: "auto", px: { xs: 2, md: 4 }, py: 6 }}>
    <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>Terms of Service</Typography>
    <Typography variant="body2" sx={{ color: "#888", mb: 3 }}>Last updated: March 2, 2026</Typography>
    <Divider sx={{ mb: 3 }} />

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>1. Age Requirement</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      InstaCamGirls is an adult entertainment platform. By accessing this site, you confirm that you are at least 18 years of age (or the age of majority in your jurisdiction, whichever is higher). If you are under 18, you must leave immediately.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>2. Nature of Service</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      InstaCamGirls is a white-label cam aggregator platform that indexes live cam performers from third-party networks including Streamate and LiveJasmin. We do not host, produce, or distribute any video content directly. All live streams are hosted by third-party cam networks.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>3. Affiliate Disclosure</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      InstaCamGirls participates in affiliate programs with third-party cam networks. When you click a performer link and register or purchase on a third-party site, we may receive a commission. This does not affect the price you pay.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>4. User Conduct</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      You agree not to: (a) use this site if you are under 18; (b) attempt to circumvent any security measures; (c) submit false, misleading, or harmful content including tags or reviews; (d) use automated tools to scrape or harvest content.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>5. User-Generated Content</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      Tags, reviews, and chat messages submitted by users are the responsibility of those users. We reserve the right to remove any content that violates these terms or applicable law.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>6. Disclaimer of Warranties</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      This site is provided "as is" without warranties of any kind. Performer availability, stream quality, and third-party site functionality are outside our control.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>7. Changes to Terms</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      We reserve the right to modify these terms at any time. Continued use of the site constitutes acceptance of the updated terms.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>8. Contact</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      For any questions regarding these terms, contact us at: legal@instacamgirls.com
    </Typography>
  </Box>
);

export default TermsPage;
